module.exports = __webpack_public_path__ + "static/media/balance_7500_10000.4ce4b24e.png";